import { PropsWithChildren } from 'react';

import { ThemeProvider as LuterkortThemeProvider } from '@ingrid/luterkort-react';
import { LogoMapProvider } from '@ingrid/react-shipping-logo';

import { AppFetchConfig } from '../config';

export function ThemeProvider({ children }: PropsWithChildren) {
  return (
    <LuterkortThemeProvider>
      <LogoMapProvider defaultVariant="Round30" host={AppFetchConfig.cdnUrl}>
        {children}
      </LogoMapProvider>
    </LuterkortThemeProvider>
  );
}
